import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { catchError, finalize, first } from "rxjs/operators";
import { Router } from "@angular/router";
import { AuthNewService } from "src/auth/services/auth-new.service";
import { EMPTY } from "rxjs";

@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.scss"],
})
export class SignInComponent implements OnInit {
  loading = false;

  form: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private auth: AuthNewService,
    private router: Router
  ) {
    this.form = this.fb.group({
      username: ["", { validators: [Validators.required, Validators.email] }],
      password: ["", Validators.required],
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    if (this.form.invalid) return;

    const { username, password } = this.form.value;

    this.loading = true;

    this.auth
      .signIn(username, password)
      .pipe(
        first(),
        catchError(() => {
          return EMPTY;
        }),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((auth) => {
        const role = auth.payload.role;
        if (role === "Admin") {
          this.router.navigate(["/app/expenses/expenses"]);
        } else if (role === "Analyst") {
          this.router.navigate(["/app/expenses/expenses"]);
        } else if (role === "User") {
          this.router.navigate(["/app/dashboard"]);
        } else {
          this.router.navigate(["/auth/sign-in"]);
        }
      });
  }
}
